/** Predugovorne informacije – Valladolid San Lorenzo rujan 2026 (HR / EN / DE / ES) */

export const valladolidSanLorenzoPreContract = {
  hr: {
    title: "Predugovorne informacije",
    content: `a1.1. Odredište/odredišta: Madrid, Valladolid, Ribera del Duero (fakultativno), Segovia (Španjolska)

a1.2. Plan putovanja: Polazak zrakoplovom Iberia iz Zagreba za Madrid 10.09.2026. Transfer prema Valladolidu, smještaj u hotelu i razgled grada (Plaza Mayor, katedrala, San Pablo, sveučilišna četvrt). Sudjelovanje u programu Fieste de San Lorenzo. 11.09. fakultativni izlet u Ribera del Duero (vinarija, degustacija) ili slobodan program u Valladolidu. 12.09. cjelodnevni izlet u Segoviju (UNESCO): akvadukt, Plaza Mayor, katedrala, židovska četvrt, Alcázar; zajednički ručak s cochinillo asado. 13.09. vlak Valladolid–Madrid, smještaj u pansionu u centru, panoramski i pješački razgled Madrida. 14.09. rani jutarnji let Madrid–Zagreb.

a1.3. Razdoblja boravka: 10.09.2026. – 14.09.2026.

a1.4. Trajanje: 5 dana / 4 noći

a2.1. Prijevoz: avion Iberia Zagreb–Madrid–Zagreb; prijevoz prema programu Madrid–Valladolid–Madrid, Valladolid–Segovia–Valladolid; vlak Valladolid–Madrid

a3.1. Smještaj: 3 noćenja s doručkom u Valladolidu (hotel); 1 noćenje s doručkom u pansionu u centru Madrida

a5.1. U cijenu uključeno: razgled Valladolida, izlet i razgled Segovije, razgled Madrida, pratitelj putovanja na hrvatskom jeziku, organizacija i jamčevina putovanja. Nije uključeno: fakultativni izlet Ribera del Duero s degustacijom vina, ulaznice za objekte, ručkovi i večere (osim zajedničkog ručka u Segoviji prema programu), putno osiguranje.

c1. Ukupna cijena paket-aranžmana (bazirano na 10 putnika): First minute 890,00 € po osobi do 10.07.2026.; redovna 990,00 € po osobi od 10.07. do 10.08.2026.; Last minute 1.090,00 € po osobi od 10.08.2026.

e1. Najmanji broj osoba potreban za ostvarivanje paket-aranžmana: 10

b1.–b4. Organizator: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1; +385 91 214 4477; info@linatravelina.eu

f1. Putovnice i vize: za državljane RH obično nisu potrebne (provjera prije puta). f3. Zdravstvene formalnosti odredišne zemlje. f4. Putno osiguranje nije uključeno u cijenu; preporučujemo Grawe; moguće uz nadoplatu.

Napomena: raspored programa po danima promjenjiv je do 2 tjedna prije puta.`,
  },
  en: {
    title: "Pre-contract Information",
    content: `a1.1. Destination(s): Madrid, Valladolid, Ribera del Duero (optional), Segovia (Spain)

a1.2. Travel plan: Iberia flight from Zagreb to Madrid on 10 September 2026. Transfer to Valladolid, hotel accommodation and city tour (Plaza Mayor, cathedral, San Pablo, university quarter). Participation in Fiesta de San Lorenzo programme. 11 September optional Ribera del Duero excursion (winery, tasting) or free time in Valladolid. 12 September full-day Segovia excursion (UNESCO): aqueduct, Plaza Mayor, cathedral, Jewish quarter, Alcázar; group lunch with cochinillo asado. 13 September train Valladolid–Madrid, guesthouse in the centre, panoramic and walking tour of Madrid. 14 September early morning flight Madrid–Zagreb.

a1.3. Period of stay: 10 September 2026 to 14 September 2026

a1.4. Duration: 5 days / 4 nights

a2.1. Transport: Iberia flight Zagreb–Madrid–Zagreb; transport per programme Madrid–Valladolid–Madrid, Valladolid–Segovia–Valladolid; train Valladolid–Madrid

a3.1. Accommodation: 3 nights with breakfast in Valladolid (hotel); 1 night with breakfast in a guesthouse in central Madrid

a5.1. Included: Valladolid tour, Segovia excursion and tour, Madrid tour, tour leader in Croatian, organisation and travel guarantee. Not included: optional Ribera del Duero excursion with wine tasting, entrance tickets, lunches and dinners (except group lunch in Segovia per programme), travel insurance.

c1. Total package price (based on 10 travellers): First minute €890.00 per person until 10 July 2026; regular €990.00 per person from 10 July to 10 August 2026; Last minute €1,090.00 per person from 10 August 2026.

e1. Minimum number of people required: 10

b1.–b4. Organizer: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1; +385 91 214 4477; info@linatravelina.eu

f1. Passports and visas: usually not required for Croatian citizens (check before travel). f3. Health formalities of the destination country. f4. Travel insurance not included; we recommend Grawe; available at extra cost.

Note: daily schedule may change up to 2 weeks before departure.`,
  },
  de: {
    title: "Vorvertragliche Informationen",
    content: `a1.1. Reiseziel(e): Madrid, Valladolid, Ribera del Duero (optional), Segovia (Spanien)

a1.2. Reiseplan: Iberia-Flug von Zagreb nach Madrid am 10.09.2026. Transfer nach Valladolid, Hotelunterkunft und Stadtrundgang (Plaza Mayor, Kathedrale, San Pablo, Universitätsviertel). Teilnahme am Fiesta de San Lorenzo. 11.09. optionaler Ausflug Ribera del Duero (Weingut, Verkostung) oder freie Zeit in Valladolid. 12.09. Ganztagesausflug Segovia (UNESCO): Aquädukt, Plaza Mayor, Kathedrale, jüdisches Viertel, Alcázar; gemeinsames Mittagessen mit Cochinillo asado. 13.09. Zug Valladolid–Madrid, Pension im Zentrum, Panorama- und Stadtrundgang Madrid. 14.09. frühmorgendlicher Flug Madrid–Zagreb.

a1.3. Aufenthaltszeitraum: 10.09.2026 bis 14.09.2026

a1.4. Dauer: 5 Tage / 4 Nächte

a2.1. Beförderung: Iberia-Flug Zagreb–Madrid–Zagreb; Transport gemäß Programm; Zug Valladolid–Madrid

a3.1. Unterkunft: 3 Nächte mit Frühstück in Valladolid (Hotel); 1 Nacht mit Frühstück in Pension im Zentrum Madrids

a5.1. Inbegriffen: Valladolid-Rundgang, Segovia-Ausflug, Madrid-Rundgang, Reiseleitung auf Kroatisch, Organisation. Nicht inbegriffen: optionaler Ribera-del-Duero-Ausflug, Eintritte, Mahlzeiten (außer Gruppenmittagessen in Segovia), Reiseversicherung.

c1. Gesamtpreis (bei 10 Reisenden): First minute 890,00 € pro Person bis 10.07.2026; regulär 990,00 € vom 10.07. bis 10.08.2026; Last minute 1.090,00 € ab 10.08.2026.

e1. Mindestteilnehmerzahl: 10

b1.–b4. Organisator: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1; +385 91 214 4477; info@linatravelina.eu

f1. Visum: für kroatische Staatsbürger in der Regel nicht erforderlich. f3. Gesundheitsformalitäten. f4. Reiseversicherung nicht inbegriffen; Grawe empfohlen.

Hinweis: Tagesablauf kann bis 2 Wochen vor Abreise angepasst werden.`,
  },
  es: {
    title: "Información precontractual",
    content: `a1.1. Destino(s): Madrid, Valladolid, Ribera del Duero (opcional), Segovia (España)

a1.2. Plan de viaje: Vuelo Iberia de Zagreb a Madrid el 10 de septiembre de 2026. Traslado a Valladolid, alojamiento en hotel y visita de la ciudad (Plaza Mayor, catedral, San Pablo, barrio universitario). Participación en la Fiesta de San Lorenzo. 11 sep excursión opcional a Ribera del Duero (bodega, cata) o tiempo libre en Valladolid. 12 sep excursión de día completo a Segovia (UNESCO): acueducto, Plaza Mayor, catedral, barrio judío, Alcázar; almuerzo grupal con cochinillo asado. 13 sep tren Valladolid–Madrid, pensión en el centro, visita panorámica y a pie de Madrid. 14 sep vuelo matutino Madrid–Zagreb.

a1.3. Periodo de estancia: del 10 al 14 de septiembre de 2026

a1.4. Duración: 5 días / 4 noches

a2.1. Transporte: vuelo Iberia Zagreb–Madrid–Zagreb; transporte según programa; tren Valladolid–Madrid

a3.1. Alojamiento: 3 noches con desayuno en Valladolid (hotel); 1 noche con desayuno en pensión en el centro de Madrid

a5.1. Incluye: visita de Valladolid, excursión y visita de Segovia, visita de Madrid, guía en croata, organización. No incluye: excursión opcional Ribera del Duero, entradas, comidas (excepto almuerzo grupal en Segovia), seguro de viaje.

c1. Precio total (basado en 10 viajeros): First minute 890,00 € por persona hasta el 10 jul 2026; regular 990,00 € del 10 jul al 10 ago 2026; Last minute 1.090,00 € desde el 10 ago 2026.

e1. Número mínimo de personas: 10

b1.–b4. Organizador: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1; +385 91 214 4477; info@linatravelina.eu

f1. Visado: normalmente no necesario para ciudadanos croatas. f3. Formalidades sanitarias. f4. Seguro de viaje no incluido; recomendamos Grawe.

Nota: el programa diario puede modificarse hasta 2 semanas antes de la salida.`,
  },
};
